<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="info" id="nav-bar">
      <b-navbar-brand href="#">
        <router-link :to="{ name: 'EnvioAvulso'}" class="navbar-brand">
          <img src="../../assets/logoMenu.png" alt="Início">
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <b-navbar-nav>
          <p class="saldo">Saldo:
            <animated-number
            :value="getSaldo"
            :formatValue="formatSaldo"
            :duration="1500"
            />
          smss</p>
        </b-navbar-nav>

       

         <!-- simples routes -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item
          :key='link.name'
          v-for="link in filterLinks(links, 'simple')">
            <router-link :to="{ name: link.name }" class="nav-link">{{link.meta.humanName}}</router-link>
          </b-nav-item>

        <!-- nested routes -->
          <b-nav-item-dropdown
            :text="link.meta.humanName"
            :key='link.name'
            v-for="link in filterLinks(links, 'nested')"
          >
            <b-dropdown-item
              :key='sublink.name'
              v-for="sublink in filterLinks(link.children, 'sublink')"
            >
              <router-link :to="{ name: sublink.name }" class="nav-link dropdown-nav-link">{{sublink.meta.humanName}}</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav v-if="lzAtivo">
            <b-nav-item :href="`${lzUrl}?token=${lzToken}`" class="nav-link" target="_blank">
              LembraZap
              <font-awesome-icon icon="paper-plane" />
            </b-nav-item>
          </b-nav>

          <b-nav-item-dropdown right>
            <template slot="button-content">
              {{ decoded.name || decoded.login}}
            </template>
            <b-dropdown-item>
            <router-link :to="{ name: 'MeuPerfil' }" class="nav-link dropdown-nav-link">
              Meus dados
              <font-awesome-icon icon="user" />
            </router-link>
            <router-link :to="{ name: 'DadosApi' }" class="nav-link dropdown-nav-link">
              Dados da API
              <font-awesome-icon icon="book" />
            </router-link>
              <div class="nav-link dropdown-nav-link" @click="logout()">
                <a href="#">
                  Sair
                  <font-awesome-icon icon="sign-out-alt" />
                </a>

              </div>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <nav aria-label="breadcrumb ">
      <ol class="breadcrumb col rounded-lg" >
        <li class="breadcrumb-item">{{breadcrumb}}</li>
      </ol>
    </nav>
  </div>
</template>

<script>
import store from '@/store';
import jwtDecode from 'jwt-decode';
import AnimatedNumber from "animated-number-vue";

const SALDO_REFRESH_MS = 60000;

export default {
  name: 'app-nav',
  data() {
    return {
      lzUrl: process.env.VUE_APP_LZURL,
      lzToken: '',
      lzAtivo: false,
      breadcrumb: '',
      decoded: '',
      api: '',
      links: [],
      saldoIntervalId: null,
    };
  },
  methods: {
    filterLinks(links, tipo) {
      let newLinks = [];

      for (let i = 0; i < links.length; i++) {
        const link = links[i];

        if ( tipo == 'sublink' && link.meta.showOnNav) {
          newLinks.push(link);
        } else if ( tipo == 'simple' && (!link.children && link.meta.showOnNav)) {
          newLinks.push(link);
        } else if ( tipo == 'nested' && (link.children && link.meta.showOnNav)) {
          newLinks.push(link);
        }

      }

      return newLinks;
    },
    formatSaldo(value) {
      return value.toFixed(0);
    },
    async refreshSaldo() {
      const token = this.$store.getters.authToken;
      if (!token) {
        return;
      }

      try {
        this.decoded = jwtDecode(token);
        let cc = await this.$http.get(`/v1/recargas/getSaldo/${this.decoded._id}`);
        this.lzToken = cc.lzToken;
        this.lzAtivo = cc.lzAtivo;
        this.$store.commit('setSaldo', cc.saldo ? cc.saldo : 0);
      } catch (error) {
        return;
      }
    },
    startSaldoRefresh() {
      if (this.saldoIntervalId) {
        return;
      }

      this.saldoIntervalId = setInterval(() => {
        this.refreshSaldo();
      }, SALDO_REFRESH_MS);
    },
    stopSaldoRefresh() {
      if (!this.saldoIntervalId) {
        return;
      }

      clearInterval(this.saldoIntervalId);
      this.saldoIntervalId = null;
    },
    logout() {
      this.$store.commit('user_logout');
    },
  },
  computed: {
    isLogged() {
      return this.$store.getters.isLogged;
    },
    getSaldo() {
      return this.$store.getters.getSaldo;
    }
  },
  async mounted() {
    this.api = process.env.VUE_APP_API;
    this.links = this.$router.options.routes;
    this.token = this.$store.getters.authToken;

    if (this.$store.getters.authToken) {
      await this.refreshSaldo();
      this.startSaldoRefresh();
    }
  },
  beforeDestroy() {
    this.stopSaldoRefresh();
  },
  watch: {
    '$route' (to, from) {
      this.breadcrumb = 'Início > ' + this.$route.meta.pathAlias;
      if (this.$store.getters.authToken) this.decoded = jwtDecode(this.$store.getters.authToken);
    },
    isLogged(isLogged) {
      if (isLogged) {
        this.refreshSaldo();
        this.startSaldoRefresh();
        return;
      }

      this.stopSaldoRefresh();
    },
  },
  components: {
    AnimatedNumber,
  }
};
</script>

<style scoped>

  .saldo {
    margin-top: 15px;
    font-size: 15px;
  }

  .breadcrumb {
    background-color: #303646;
    color: #999
  }

  .nav-item.b-nav-dropdown.dropdown {
    margin-top: 10px;
  }

</style>
